/* eslint-disable */
import * as Types from '../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetProjectQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetProjectQuery = { __typename: 'Query', getCampaign: { __typename: 'Campaign', editable: boolean | null, active: boolean | null, id: string | null, info: string | null, team_info: string | null, main_product_id: number | null, name: string | null, owner_id: number | null, original_campaign_id: string | null, parent_id: string | null, unit_id: number | null, label_id: string | null, project_id: string | null, created_at: string | null, gcdmLabel: string | null, isaac_url: Array<{ __typename: 'ISAAC', title: string | null, url: string | null } | null> | null, children: Array<{ __typename: 'Campaign', id: string | null, label_id: string | null, global_status: Types.GlobalStatus | null }> | null, user: { __typename: 'User', first_name: string, email: string, last_name: string } | null, parent: { __typename: 'Campaign', id: string | null, parent_id: string | null, original_campaign_id: string | null, global_status: Types.GlobalStatus | null, info: string | null, team_info: string | null, isaac_url: Array<{ __typename: 'ISAAC', title: string | null, url: string | null } | null> | null } | null, unit: { __typename: 'Unit', name: string, id: string, alias: string } | null, artist: { __typename: 'Artist', label_id: string | null, bio: string | null, facebook_id: string | null, spotify_id: string | null, gfk_id: number | null, gps_status: string | null, id: string | null, name: string | null, opus_id: string | null, gcdm_info: { __typename: 'GcdmInfo', company: string | null, country: string | null, genre: string | null } | null, image_url_data: { __typename: 'ImageUrlData', thumbnailUrl: string | null, imageUrl: string | null, headerUrl: string | null } | null } | null } | null };


export const GetProjectDocument = gql`
    query getProject($id: String!) {
  getCampaign(id: $id) {
    editable
    active
    id
    info
    team_info
    isaac_url {
      title
      url
    }
    children {
      id
      label_id
      global_status
    }
    main_product_id
    name
    owner_id
    user {
      first_name
      email
      last_name
    }
    parent {
      id
      parent_id
      original_campaign_id
      global_status
      info
      team_info
      isaac_url {
        title
        url
      }
    }
    original_campaign_id
    parent_id
    unit_id
    unit {
      name
      id
      alias
    }
    label_id
    project_id
    created_at
#    gcdmLabel
    artist {
      label_id
      bio
      facebook_id
      gcdm_info {
        company
        country
        genre
      }
      spotify_id
      gfk_id
      gps_status
      id
      name
      opus_id
      image_url_data {
        thumbnailUrl
        imageUrl
        headerUrl
      }
    }
  }
}
    `;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectQuery(baseOptions: Apollo.QueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
      }
export function useGetProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;